import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Routes, Route, Link, Outlet } from 'react-router-dom';
import About from './components/About';
import Home from './components/Home';
import Job from './components/Job';

import './App.scss';


function App() {
  return (
    <div className="App">
    <Routes>
      <Route exact path='/' element={< Home />}></Route>
      <Route exact path='/about' element={< About />}></Route>
      <Route exact path='/job' element={< Job />}></Route>
      <Route path="/:id" element={<Job />} />
    </Routes>
</div>
  );
}

export default App;
